module.exports = __webpack_public_path__ + "static/media/40-iveco.b40c5f23.jpg";